import request, { ResponseData } from '@/utils/request'
import { ShopList } from '@/types/shop'

// 获取 Claw 欢迎页的推荐指令
export async function runAgentOs(params: {
  agent_id: string
  params?: Record<string, unknown>
  signal?: AbortSignal
}) {
  return request('/api/v1/ai/agent/run', {
    method: 'post',
    data: params,
    signal: params.signal,
  })
}

// 文件上传
export async function uploadFile(params) {
  return request('/api/v1/file/upload', { method: 'post', data: params })
}

// 获取商品列表
export async function fetchGoodList(params) {
  return request('/api/v1/dialog/focus_goods_list', { method: 'post', data: params })
}

// 获取行业列表
export async function fetchBusinessList(params) {
  return request('/api/v1/shop/question_b', { method: 'get', params })
}

// 获取行业场景
export async function fetchIndustry(params) {
  return request('/api/v1/shops/question_b', { method: 'post', data: params })
}

// 获取质检标准列表
export async function fetchStandards(params) {
  return request('/api/v1/qc_norm/list', {
    method: 'post',
    data: params,
  })
}

// 获取标签列表
export async function fetchLabels(): Promise<ResponseData<LabelList>> {
  return request('/api/v1/label/list', {
    method: 'post',
  })
}

// 获取分组列表
export async function fetchDepartments(): Promise<ResponseData<LabelList>> {
  return request('/api/v1/department/list', {
    method: 'post',
  })
}

// 获取商品列表
export async function fetchShops(): Promise<ResponseData<{ shops: ShopList }>> {
  return request('/api/v1/shop/get_company_shop', { method: 'post' })
}

// 获取子账号
export async function fetchSnicks(params) {
  return request('/api/v1/snick/simple_list', { method: 'post', params })
}

// 获取员工
export async function fetchEmployees(params) {
  return request('/api/v1/employee/all', {
    method: 'post',
    data: { ...params },
  })
}

// 获取新的客服人员
export async function fetchStaff(params) {
  return request('/api/v1/employee/list/by-permit', {
    method: 'post',
    data: { ...params },
  })
}

// 获取店铺客服
export async function fetchAccounts(params) {
  return request('/api/v1/account/list', { method: 'post', params })
}

// 获取场景标签
export async function fetchSceneLabels(params) {
  return request('/api/v1/scene_label/list', {
    method: 'post',
    data: params,
  })
}

export function gtpConversion(params) {
  return request('/api/v1/chat/conversion', {
    method: 'post',
    data: params,
  })
}

export function getGtpHistory(params) {
  return request('/api/v1/chat/history', {
    method: 'post',
    data: params,
  })
}

export function exportVoc(params) {
  return request('/api/v1/voc/goods/focus/export', {
    method: 'post',
    data: params,
  })
}

export async function saveHelpDoc(params: { id: string; link: string; password: string }) {
  return request('/api/v1/admin/help_doc/save', {
    method: 'post',
    data: params,
  })
}

export async function fetchHelpDoc() {
  return request('/api/v1/help_doc/get', {
    method: 'get',
  })
}

export function exportFocus(params) {
  return request('/api/v1/chat/export_focus', {
    method: 'post',
    data: params,
  })
}

export function conversionContinue(params) {
  return request('/api/v1/chat/conversion_continue', {
    method: 'post',
    data: params,
  })
}

export function conversionStatus(params) {
  return request('/api/v1/chat/conversion_status', {
    method: 'post',
    data: params,
  })
}

export function fetchCaseLabels(params) {
  return request('/api/v1/dialog/case/list_label', {
    method: 'post',
    data: params,
  })
}

// 获取doris白名单
export function centerWhitelist() {
  return request('/api/v1/center_whitelist/data_force_doris', {
    method: 'post',
  })
}
